import { render, staticRenderFns } from "./ProjectDetailing.vue?vue&type=template&id=2292f292&scoped=true&"
import script from "./ProjectDetailing.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailing.vue?vue&type=style&index=0&id=2292f292&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292f292",
  null
  
)

export default component.exports